module.exports = __webpack_public_path__ + "static/media/2022-02-27 15.06.26.c6cd9ada.png";